<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="center" style="">
      <div class="header-title">
        <p class="title_">Todos os centros de custos desta filial</p>
        <el-input
          style="width: 300px; margin-right: 130px"
          v-model="search"
          size="medium"
          placeholder="Fazer busca"
          clearable
          :value="search"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="table-teste" v-if="finshedLoad && dataTable.length > 0">
        <el-table
          :highlight-current-row="true"
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{ color: '#333' }"
          :default-sort="{ prop: 'name', order: 'descending' }"
          @sort-change="handleSort"
          @row-click="handleRowClick"
          :data="handleSearch"
          style="width: 100%"
        >
          <el-table-column
            label="Código CC"
            prop="cost_center"
            sortable="custom"
          />
          <el-table-column label="Nome CC" prop="name" sortable="custom" />
          <el-table-column
            sortable="custom"
            label="Percentual indireto"
            prop="indirect_percentage"
          >
            <template slot-scope="scope">
              <el-progress
                :text-inside="false"
                :stroke-width="10"
                :percentage="
                  parseFloat(formatterNumber(scope.row.indirect_percentage))
                "
                color="#e87305"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            label="Percentual acumulado"
            prop="accumulated_percentage"
          >
            <template slot-scope="scope">
              <el-progress
                :text-inside="false"
                :stroke-width="10"
                :percentage="
                  parseFloat(formatterNumber(scope.row.accumulated_percentage))
                "
                color="#e87305"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="Ações" width="180">
            <template slot-scope="scope">
              <b-icon
                style="margin-left: 10%"
                class="icon-beaut"
                icon="pencil"
                font-scale="1.2"
                @click="handleCurrentProject(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <Paginator
            :pageSize="pageSize"
            :total="dataTableTemp.length"
            :start="(page - 1) * pageSize + 1"
            :end="
              page * pageSize > dataTableTemp.length
                ? dataTableTemp.length
                : (page - 1) * pageSize + pageSize
            "
            @set-page-size="setCurrentPageSize"
          />
          <el-pagination
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :total="dataTableTemp.length"
            :page-size="pageSize"
            :current-page="page"
            @current-change="setPage"
          />
        </div>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          :rows="8"
          animated
          v-if="!finshedLoad"
          style="width: 90%"
        />
        {{
          dataTable.length === 0 && finshedLoad ? "Sem dados para exibir." : ""
        }}
      </div>
    </div>
    <el-drawer
      title="Editar"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      :wrapperClosable="false"
    >
      <div class="drawer">
        <div class="drawer-text-header">
          <span class="drawer-text-title">Centro de custo</span>
          <span class="drawer-text">{{ currentCostCenter }}</span>
        </div>
        <div class="drawer-content">
          <div style="display: flex; flex-direction: column">
            <span class="drawer-text-title">Alterar percentual acumulado</span>
            <span class="drawer-text-sm">Percentual:</span>
            <div class="drawer-inner-content">
              <el-input
                id="inputDrawer"
                style="width: 130px; margin-right: 10px"
                v-model="currentPercentage"
                type="number"
                size="medium"
                placeholder="Percentual"
                :value="currentPercentage"
              >
              </el-input>
              <span style="font-size: 12px">%</span>
            </div>
          </div>
          <div class="drawer-footer">
            <el-button
              style="background: #eaeaea; color: #515151"
              type="text"
              @click="handleDrawerCancel"
              >cancelar</el-button
            >
            <el-button @click="savePercentage" :loading="isLoadingBtnConfirm"
              >Salvar</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<style scoped>
.el-button {
  background: #e87305;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.el-button:hover {
  background: #c76000;
  color: #fff;
}

.el-button:focus {
  background: #e87305;
  color: #fff;
}

.el-button:disabled {
  background: #e87305;
  opacity: 0.5;
}

.el-button:disabled:hover {
  background: #e87305;
  opacity: 0.5;
}

.icon-beaut {
  cursor: pointer;
  margin-right: 4px;
}

.icon-beaut:hover {
  color: #e87305;
}

.my-header {
  background: blue !important;
}

.confirm-items {
  display: flex;
  padding-top: 8px;
  padding-right: 15px !important;
}

.title_ {
  color: #515151;
  font-weight: bold;
}

.link-download {
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  color: rgb(0, 140, 202);
}

.link-download:hover {
  color: rgb(0, 140, 202);
  text-decoration: underline;
}

.btnFalses {
  background-color: #e87305 !important;
  border: none;
}

.btnFalses:hover {
  background-color: #d66800 !important;
  border: none;
}

.btnCancelFalses {
  background-color: #eaeaea !important;
  color: #515151 !important;
  border: none;
}

.right-position {
  display: flex;
  margin-top: 20px;
}

.alert-class {
  padding-bottom: 20px;
}

.el-icon-close:hover {
  color: #e87305 !important;
}

.number.active {
  color: #e87305 !important;
}

.number:hover {
  color: #e87305 !important;
}

.el-icon:hover {
  color: #e87305 !important;
}

.btn-next:hover {
  color: #e87305 !important;
}

.btn-prev:hover {
  color: #e87305 !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";
import api from "../utils/api";
import dayjs from "../utils/dayjs";

import Paginator from "../components/Paginator.vue";
import sortDataTable from "../utils/sortDataTable";

export default {
  name: "CostCenters",
  components: {
    Paginator,
  },
  data() {
    return {
      locationId: null,
      isLoadingBtnConfirm: false,
      dayjs: dayjs,
      direction: "rtl",
      finshedLoad: false,
      page: 1,
      pageSize: 10,
      dataTable: [],
      dataTableTemp: [],
      search: "",
      drawer: false,
      currentCostCenter: "CENTRO CUSTO 5.2.09.010",
      currentPercentage: 0,
      currentCostCenterId: "",
      searchColumns: [
        "name",
        "cost_center",
        "indirect_percentage",
        "accumulated_percentage",
      ],
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "getCostCenters", "formatterNumber"]),
    pagedTableData() {
      const data = this.dataTableTemp.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
      if (data.length === 0) {
        this.page = 1;
      }
      return data;
    },
    handleSearch() {
      if (this.search.length > 0) {
        this.dataTableTemp = this.dataTable.filter((item) => {
          for (let value of this.searchColumns) {
            if (
              String(item[value])
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
              return item;
          }
        });
      } else {
        this.dataTableTemp = this.dataTable;
      }
      return this.pagedTableData;
    },
  },
  async created() {
    this.updateNavCurrentIndex("2");
    this.finshedLoad = false;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.updateNavItems_(array_teste);
    this.dataTable = this.getCostCenters || [];
    this.getCostcentersByRegion();
    this.dataTableTemp = this.dataTable;
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
    getCostCenters: function (val) {
      this.dataTable = val;
      this.finshedLoad = true;
    },
  },
  methods: {
    ...mapActions([
      "updateNavItems",
      "updateNavCurrentIndex",
      "updateCostCenters",
    ]),
    async getCostcentersByRegion() {
      const { data } = await api.get("/findAllCostCenters", {
        params: { locale: this.locationId },
      });
      this.updateCostCenters(data);
      this.finshedLoad = true;
    },
    setPage(val) {
      this.page = val;
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleDrawerCancel() {
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      this.drawer = false;
      this.isLoadingBtnConfirm = false;
    },
    handleCurrentProject(row) {
      this.currentCostCenter = row.name;
      this.currentCostCenterId = row.id;
      this.currentPercentage = row.accumulated_percentage;
      this.drawer = true;
      this.isLoadingBtnConfirm = false;
    },
    handleClose() {
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      this.drawer = false;
      this.isLoadingBtnConfirm = false;
    },
    savePercentage() {
      this.isLoadingBtnConfirm = true;
      this.$confirm(
        "Deseja salvar a alteração realizada?",
        `Salvar informações`,
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: "alert-class",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Atualizando...";
              api
                .put(
                  `/updateAccumulatedPercentage/${this.currentCostCenterId}`,
                  {
                    accumulated_percentage: parseFloat(this.currentPercentage),
                  }
                )
                .then(async ({ data }) => {
                  await this.updateCostCenters(
                    this.dataTable.map((item) =>
                      item.id === data.id
                        ? {
                            ...item,
                            accumulated_percentage: data.accumulated_percentage,
                          }
                        : item
                    )
                  );
                  this.dataTable = this.getCostCenters;
                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.drawer = false;
                  done();
                  this.$message({
                    type: "success",
                    message: "Atualizado com sucesso!",
                  });
                })
                .catch(() => {
                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.$message({
                    type: "error",
                    message: "Erro ao tentar salvar informações.",
                  });
                });
            } else {
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonLoading = false;
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonText = "Confirmar";
              done();
            }
          },
        }
      )
        .then(() => {})
        .catch(() => {
          this.isLoadingBtnClose = false;
        });
    },
    handleRowClick(row) {
      if (!this.drawer) {
        this.$router.push({
          name: "apportionmentByCostcenter",
          params: { id: row.id },
        });
      }
    },
    setCurrentPageSize(pageSize) {
      this.setPage(1);
      this.pageSize = pageSize.size;
    },
    handleSort(column) {
      this.dataTable = sortDataTable(this.dataTable, column);
    },
  },
};
</script>
